import { motion } from "framer-motion";
import "../styles/Teamhero.css";

export default function HeroSection() {
  return (
    <section className="Team-hero-section">
      <div className="Team-overlay">
        <motion.div
          className="Team-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <h1 className="Team-title">Operational Team </h1>
        </motion.div>
      </div>
    </section>
  );
}
